require('./bootstrap');

Main = {
	// Variables.
	baseUrl: window.location.origin,
	tags:{},
	/**
	 * Initialization.
	 *
	 */
	init: function () {
		this.ajaxSetup();
		this.validationConfig();
		this.addValidationRules();
		this.logout();
		this.sidebar();
		this.changeLanguages();

		console.log('Logs: Main script init.');
	},

	/**
	 * Configure languages.
	 *
	 */
	initTags: function (tags) {
		this.tags = tags;
	},
	/**
	 * Configure tags.
	 *
	 */
	tag: function (tag) {
		if (this.tags.hasOwnProperty(tag)) {
           return this.tags[tag];
        } 
		return tag;
	},


	/**
	 * Configure global ajax.
	 *
	 */
	ajaxSetup: function () {
		$.ajaxSetup({
			headers: {
				'Accept': 'application/json',
				'Authorization': Cookies.get('token') ? 'Bearer ' + Cookies.get('token') : '',
				'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
			}
		});
	},

	/**
	 * Configure global jquery validation.
	 *
	 */
	validationConfig: function () {
		$.validator.setDefaults({
            ignore: [],
			errorElement: 'span',
			errorClass: 'is-invalid',
			errorPlacement: function(error, element) {
				if(element.parent('.input-group').length) {
					error.insertAfter(element.parent());
				} /*else if(element.hasClass('js-open-usasf')) {
                    error.insertAfter('<br>');
                    error.insertAfter(element);
                }*/ else {
					error.insertAfter(element);
				}

				$('html, body').animate({
					scrollTop: error.offset().top - 300
				}, 50);
			},
			invalidHandler: function(event, validator) {
				var errors = validator.numberOfInvalids();
				if (errors) {
					if ($(".is-invalid").length) {
						$('html, body').animate({
							scrollTop: ($(".is-invalid").first().offset().top - 300)
						},50);
					}
				}
			}
		});
	},

	/**
	 * Create custom validation rules.
	 *
	 */
	addValidationRules: function () {
		$.validator.addMethod('phone', function(phone_number, element) {
			phone_number = phone_number.replace(/\s+/g, "");
			return this.optional(element) || phone_number.length > 9 &&
				phone_number.match(/^(\+?1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
		}, "Please specify a valid phone number");
	},

	/**
	 * Logout in system.
	 *
	 */
	logout: function (){
		const that = this;

		$(document).ready(function() {
			$('.js-btn-logout').on('click', function (){
				$.ajax({
					type: 'DELETE',
					url: that.baseUrl + '/api/v1/logout',
					success:function(data) {
						Cookies.remove('token');
						Cookies.remove('users_role_token');
						Cookies.remove('icdr_session');
                        if($('.js-custom-url').val()) {
                            window.location.replace('/reg/'+$('.js-custom-url').val());
                        } else {
                            window.location.replace('/login');
                        }
					},
					error: function (error) {
						console.error(error);
					},
				});
			});
		});
	},

	/**
	 * Sidebar menu.
	 *
	 */
	sidebar: function (){
		var that = this;
		$(document).ready(function() {
			const btnSidebarCollapse = $('.js-btn-sidebar-collapse');
			// that.toggleSidebar()
			btnSidebarCollapse.on('click', function () {
				$('#sidebar').toggleClass('active');
				// that.toggleSidebar()
			});
		});
	},
	toggleSidebar: function () {
		if($(window).width() < 1200){
			// if($('#sidebar').hasClass('active')) {
			//     $('.js-sidebar-action-header').hide();
			//     $('.js-sidebar-action-reverse-header').show();
			// } else {
			//     $('.js-sidebar-action-header').show();
			//     $('.js-sidebar-action-reverse-header').hide();
			// }
		} else {
			if($('#sidebar').hasClass('active')) {
				$('.js-sidebar-action-header').show();
				$('.js-sidebar-action-reverse-header').hide();
			} else {
				$('.js-sidebar-action-header').hide();
				$('.js-sidebar-action-reverse-header').show();
			}
		}
	},
	changeLanguages: function () {
		$(document).on('click', '.js-language',function() {
			let language_id = $(this).attr('data-language_id');
			if (language_id != $('#js-ff1-lang #js-languagesID').val()) {
				$('#js-languagesID').val(language_id);
				$('#js-ff1-lang').submit();
			}
		});
	}
};

// Start Initialization.
Main.init();
